import { BaseOptionsLoader } from '@pages/AdditionalServices/containers/services/optionsLoader/BaseOptionsLoader';
import { ContractorProcessor } from '@pages/AdditionalServices/containers/services/optionsLoader/ContractorProcessor';
import { CurrencyProcessor } from '@pages/AdditionalServices/containers/services/optionsLoader/CurrencyProcessor';
import { HandbookProcessor } from '@pages/AdditionalServices/containers/services/optionsLoader/HandbookProcessor';
import { LocationProcessor } from '@pages/AdditionalServices/containers/services/optionsLoader/LocationProcessor';
import { TaxProcessor } from '@pages/AdditionalServices/containers/services/optionsLoader/TaxProcessor';

import { EcoFeePackageProcessor } from './EcoFeePackageProcessor';
import { EcoFeeProductProcessor } from './EcoFeeProductProcessor';

// optionsLoader реализует фабрику сервиса.
const optionsLoader = () =>
  new BaseOptionsLoader([
    new HandbookProcessor(),
    new CurrencyProcessor(),
    new TaxProcessor(),
    new LocationProcessor(),
    new EcoFeePackageProcessor(),
    new EcoFeeProductProcessor(),
    new ContractorProcessor('consulting_contractor', 'consulting'),
    new ContractorProcessor('inspection_contractor', 'inspection'),
    new ContractorProcessor('certification_contractor', 'certification'),
    new ContractorProcessor('customs_contractor', 'customs'),
    new ContractorProcessor('insurance_contractor', 'insurance'),
  ]);

export default optionsLoader;
